<template>
  <div class="py-4 container-fluid">
    <div v-if="!isLoading" class="row">
      <div class="col-12">
        <navbaroptions
          isBlur="blur border-radius-lg py-2 start-0 end-0 mb-3 shadow"
          v-bind:darkMode="true"
          isBtn="bg-gradient-success"
          toRoute="/bypass-card/0"
        />
      </div>
      <div
        class="col-lg-4 col-md-4 col-12"
        v-for="bypass in bypasses"
        :key="bypass.id"
      >
        <router-link :to="`/bypass-card/${bypass.id}`">
          <card
            :bypassID="bypass.id.toString()"
            :title="
              bypass.name.includes('-')
                ? bypass.name.toUpperCase().includes('RIOVERDE')
                  ? 'CONEXIÓN'
                  : 'CASETA'
                : 'LIBRAMIENTO'
            "
            :value="bypass.name"
            percentage="S.L.P"
            iconClass="ni ni-money-coins"
            iconBackground="bg-primary"
            detail="META"
            directionReverse
          />
        </router-link>
      </div>
    </div>
  </div>
</template>
<script>
import Card from "@/examples/Cards/Card.vue";
import Navbaroptions from "@/examples/PageLayout/Navbaroptions.vue";
//import { activateDarkMode } from "@/assets/js/dark-mode";
export default {
  name: "bypass-default",
  components: {
    Card,
    Navbaroptions,
  },
  data() {
    return {
      bypasses: undefined,
      isLoading: true,
    };
  },
  created() {
    this.plain
      .get(`/bypasses`)
      .then((response) => {
        if (response.data.length !== 0) this.bypasses = response.data;
        else this.bypasses = [];
        this.isLoading = false;
      })
      .catch((err) => {
        this.bypasses = [];
        this.isLoading = false;
        console.log(err);
      });
  },
};
</script>
